import { ActorType, IActor } from '../models';

export const onlyIndividuals = (actor: IActor) => actor.type === ActorType.INDIVIDUAL;
export const onlyContractualPartners = (actor: IActor) => Boolean(actor.individualDetails?.isActualContractPartner);
export const onlyUbos = (actor: IActor) => Boolean(actor.individualDetails?.isBeneficialOwner);
